/**
 * Merges a query string (`?experienceId=x` or `experienceId=x`) into a URL that may already carry one,
 * dropping any fragment. Mirrors the API sitemap's `buildListingUrl` (`URL.searchParams.set`), so a
 * canonical built here is the exact string the sitemap emits for the same listing. Falls back to a
 * plain join when the base isn't a parseable absolute URL.
 */
const mergeSearchIntoUrl = (base: string, search: string): string => {
  const params = new URLSearchParams(search);
  try {
    const url = new URL(base);
    params.forEach((value, key) => url.searchParams.set(key, value));
    url.hash = '';
    return url.toString();
  } catch {
    const [withoutHash] = base.split('#');
    const query = params.toString();
    if (!query) return withoutHash;
    return `${withoutHash}${withoutHash.includes('?') ? '&' : '?'}${query}`;
  }
};

export default mergeSearchIntoUrl;
